"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreLogoutModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const Base_1 = require("./Base");
const buttons_1 = require("../../atoms/buttons");
const typography_1 = require("../../shared/typography");
const react_i18next_1 = require("react-i18next");
const PreLogoutModal = ({ onClick }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(Base_1.ModalBase, { children: (0, jsx_runtime_1.jsx)(Wrapper, { children: (0, jsx_runtime_1.jsxs)(Content, { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: t("preLogoutModal.title") }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: t("preLogoutModal.paragraph") }, void 0), (0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "primary", onClick: onClick, children: t("preLogoutModal.button") }, void 0)] }, void 0)] }, void 0) }, void 0) }, void 0));
};
exports.PreLogoutModal = PreLogoutModal;
const Wrapper = styled_components_1.default.div `
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
`;
const Content = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  max-width: 571px;
  width: 100%;

  h2,
  p {
    line-height: 1.5rem;
    margin-bottom: 0;
  }

  h2 {
    border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
    padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};
  }

  & > div {
    padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};

    p {
      margin-bottom: ${({ theme }) => theme.spacings.m};
    }
  }
`;
//# sourceMappingURL=PreLogout.js.map